import { combineReducers } from 'redux';
import auth from './authReducer';
import elections from './electionsReducer'; // Fixed import name
import divisions from './divisionsReducer';
import subDivisions from './subDivisionsReducer';
import application from './applicationReducer';
import intrestedcandidate from './intrestedcandidatereducer';    
import subsection from './subsectionReducer';
import shedulemeeting from './SheduleMeetingReducer';
import candidate from './candidateReducer';
export default combineReducers({
    auth,
    elections,
    divisions,
    subDivisions,
    application,
    intrestedcandidate,
     subsection,
        shedulemeeting,
        candidate,
});